import { Box, Modal } from "@mui/material";
import "./Loaders.scss"
import { useState } from "react";

const Loader = () => {

    return(
        <Box sx={{backgroundColor:"rgba(0,0,0,0.5)", position:"fixed", display:"flex", justifyContent:"center",
            right:0, left:0, top:0, bottom:0, zIndex:1400
        }}>
            <div className="loader"></div>
        </Box>
    )
}

export default Loader;